import { type ReactNode, useMemo } from "react";
import type { ScheduleAlertLevel } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlertLevel.ts";
import type { ScheduleAlert } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlert.ts";
import ScheduleAlertRow from "@/pages/human-resources/time-management/components/schedule-alerts/alerts-list/ScheduleAlertRow.tsx";
import AlertsGroupTitle from "@/pages/human-resources/time-management/components/schedule-alerts/alerts-list/AlertsGroupTitle.tsx";

interface Properties {
  level: ScheduleAlertLevel;
  alerts: ScheduleAlert[];
  revealEmployeeId: (id: string) => boolean;
}

export default function ScheduleAlertsGroup(props: Properties): ReactNode {
  const uniqueAlerts = useMemo(() => deduplicate(props.alerts), [props.alerts]);

  if (uniqueAlerts.length === 0) {
    return;
  }
  return (
    <div>
      <AlertsGroupTitle level={props.level} count={uniqueAlerts.length} />
      <>
        {uniqueAlerts.map((a, index) => {
          return (
            <ScheduleAlertRow
              key={index}
              alert={a}
              revealEmployeeId={props.revealEmployeeId}
            />
          );
        })}
      </>
    </div>
  );
}

function deduplicate(alerts: ScheduleAlert[]): ScheduleAlert[] {
  // Here, alerts are expected to have the same level.
  const res: ScheduleAlert[] = [];
  const found: Set<string> = new Set<string>();
  for (const alert of alerts) {
    const string = `${alert.employeeId}|${alert.htmlMessage}`;
    if (!found.has(string)) {
      found.add(string);
      res.push(alert);
    }
  }
  return res;
}
